import { render } from "./VerifyDashboard.vue?vue&type=template&id=39ccec2b&scoped=true"
import script from "./VerifyDashboard.vue?vue&type=script&lang=js"
export * from "./VerifyDashboard.vue?vue&type=script&lang=js"

import "./VerifyDashboard.vue?vue&type=style&index=0&id=39ccec2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ccec2b"]])

export default __exports__